import React from "react";
import { Button, Card, Descriptions, Tag, Typography } from "antd";

const { Title } = Typography;

export default function StepConfirm({ formData ,setStep }) {
  // const amount =
  //   formData.payment?.data?.appointment?.payment?.amount?.amount / 100 || "0.00";

    const amountInCents = formData?.payment?.data?.appointment?.payment?.amount?.amount ?? 0;
const amount = (amountInCents / 100)?.toFixed(2);

  const currency =
    formData.payment?.data?.appointment?.payment?.amount?.currency || "USD";
  const status = formData.payment?.data?.appointment?.status || "Pending";
  const receiptUrl =
    formData.payment?.data?.appointment?.payment?.receiptUrl || null;

    const handleBtn = () => {
      localStorage.removeItem("currentStep");
      localStorage.removeItem("formData");
       setStep(0)
    }
  return (
    <div className="step-confirm flex justify-center mt-6">
      <Card
        className="shadow-lg w-full max-w-2xl"
        bordered={false}
        style={{ borderRadius: 12 }}
      >
        <Title level={3} style={{ marginBottom: 24, textAlign: "center" }}>
          Booking Summary
        </Title>

        <Descriptions
          column={1}
          bordered
          size="middle"
          labelStyle={{ fontWeight: "600", width: "30%" }}
          contentStyle={{ background: "#fafafa" }}
        >
          <Descriptions.Item label="Service">
            {formData.service?.visit_type}
          </Descriptions.Item>
          <Descriptions.Item label="Date">
            {formData.schedule?.date}
          </Descriptions.Item>
          <Descriptions.Item label="Time">
            {formData.schedule?.start_time} – {formData.schedule?.end_time}
          </Descriptions.Item>
          <Descriptions.Item label="Amount Paid">
            💲{amount} {currency}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag
              color={status === "Confirmed" ? "green" : "orange"}
              style={{ fontSize: "14px", padding: "4px 12px" }}
            >
              {status}
            </Tag>
          </Descriptions.Item>
         
        </Descriptions>
         <Button className="btn-css-class" onClick={() => handleBtn()} block>
      Back
    </Button>
      </Card>
    </div>
  );
}
